import api from './api';

/**
 * Fetch all currency rates (admin endpoint)
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number
 * @param {number} params.per_page - Items per page
 */
export const fetchCurrencyRates = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.page) queryParams.append('page', params.page);
  if (params.per_page) queryParams.append('per_page', params.per_page);
  
  const endpoint = `/admin/currency-rates${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  const response = await api.get(endpoint);
  return response.data;
};

/**
 * Fetch the latest currency rate (for system use)
 */
export const fetchLatestCurrencyRate = async () => {
  const response = await api.get('/admin/currency-rates/latest');
  return response.data;
};

/**
 * Fetch a single currency rate by ID
 * @param {number} id - Currency rate ID
 */
export const fetchCurrencyRate = async (id) => {
  const response = await api.get(`/admin/currency-rates/${id}`);
  return response.data;
};

/**
 * Create a new currency rate
 * @param {Object} data - Currency rate data
 */
export const createCurrencyRate = async (data) => {
  const response = await api.post('/admin/currency-rates', data);
  return response.data;
};

/**
 * Update an existing currency rate
 * @param {number} id - Currency rate ID
 * @param {Object} data - Updated currency rate data
 */
export const updateCurrencyRate = async (id, data) => {
  const response = await api.put(`/admin/currency-rates/${id}`, data);
  return response.data;
};

/**
 * Delete a currency rate
 * @param {number} id - Currency rate ID
 */
export const deleteCurrencyRate = async (id) => {
  const response = await api.delete(`/admin/currency-rates/${id}`);
  return response.data;
};
